import DesignTokens from "@ubie/design-tokens";
const opacityToClassName = (opacity) => {
  switch (opacity) {
    case "normal":
      return "normalOverlay";
    case "darker":
      return "darkerOverlay";
  }
};
const createSpacingVariableFromKey = (key) => {
  return `var(--${DesignTokens.size[`spacing-${key}`].path.join("-")})`;
};
const createRadiusVariableFromKey = (key) => {
  return `var(--${DesignTokens.radius[key].path.join("-")})`;
};
const cssFontSizeToken = ({
  type,
  size
}) => {
  switch (type) {
    case "body":
      return `var(--${DesignTokens.text[`${type}-${size}-size`].path.join("-")})`;
    case "note":
      return `var(--${DesignTokens.text[`${type}-${size}-size`].path.join("-")})`;
    case "heading":
      return `var(--${DesignTokens.text[`${type}-${size}-size`].path.join("-")})`;
    case "button":
      return `var(--${DesignTokens.text[`${type}-${size}-size`].path.join("-")})`;
    case "tag":
      return `var(--${DesignTokens.text[`${type}-${size}-size`].path.join("-")})`;
    default:
      const _ = type;
  }
  return "";
};
const cssLeadingToken = ({
  type,
  size,
  leading
}) => {
  switch (type) {
    case "body":
      return leading === "default" ? `var(--${DesignTokens.text[`${type}-${size}-line`].path.join("-")})` : `var(--${DesignTokens.text[`${type}-${size}-${leading}-line`].path.join("-")})`;
    case "heading":
      return `var(--${DesignTokens.text[`${type}-${size}-line`].path.join("-")})`;
    case "note":
      return leading === "default" ? `var(--${DesignTokens.text[`${type}-${size}-line`].path.join("-")})` : `var(--${DesignTokens.text[`${type}-${size}-${leading}-line`].path.join("-")})`;
    case "button":
      return `var(--${DesignTokens.text[`${type}-${size}-line`].path.join("-")})`;
    case "tag":
      return `var(--${DesignTokens.text[`${type}-${size}-line`].path.join("-")})`;
    default:
      const _ = type;
  }
  return "";
};
const colorVariable = (color) => {
  if (color == null) {
    return {
      "--text-color": "inherit"
    };
  }
  let _color = "";
  if (color === "linkSub") {
    _color = `var(--${DesignTokens.color[`text-link-sub`].path.join("-")})`;
  } else if (color === "primary") {
    _color = `var(--${DesignTokens.color["primary"].path.join("-")})`;
  } else if (color === "accent") {
    _color = `var(--${DesignTokens.color["accent"].path.join("-")})`;
  } else if (color === "alert") {
    _color = `var(--${DesignTokens.color["alert"].path.join("-")})`;
  } else {
    _color = `var(--${DesignTokens.color[`text-${color}`].path.join("-")})`;
  }
  return {
    "--text-color": _color
  };
};
const paddingVariables = ({
  p,
  px,
  py,
  pt,
  pr,
  pb,
  pl
}) => {
  const topKey = pt ?? py ?? p;
  const rightKey = pr ?? px ?? p;
  const bottomKey = pb ?? py ?? p;
  const leftKey = pl ?? px ?? p;
  return {
    "--padding-top": topKey ? createSpacingVariableFromKey(topKey) : "0",
    "--padding-right": rightKey ? createSpacingVariableFromKey(rightKey) : "0",
    "--padding-bottom": bottomKey ? createSpacingVariableFromKey(bottomKey) : "0",
    "--padding-left": leftKey ? createSpacingVariableFromKey(leftKey) : "0"
  };
};
const marginVariables = ({
  m,
  mx,
  my,
  mt,
  mr,
  mb,
  ml
}) => {
  const topKey = mt ?? my ?? m;
  const rightKey = mr ?? mx ?? m;
  const bottomKey = mb ?? my ?? m;
  const leftKey = ml ?? mx ?? m;
  return {
    "--margin-top": topKey ? createSpacingVariableFromKey(topKey) : "0",
    "--margin-right": rightKey ? createSpacingVariableFromKey(rightKey) : "0",
    "--margin-bottom": bottomKey ? createSpacingVariableFromKey(bottomKey) : "0",
    "--margin-left": leftKey ? createSpacingVariableFromKey(leftKey) : "0"
  };
};
const radiusVariables = (radius) => {
  return {
    "--radius": radius ? createRadiusVariableFromKey(radius) : "0"
  };
};
const gapVariables = (spacing) => {
  return {
    "--gap": spacing ? `var(--size-spacing-${spacing})` : "0"
  };
};
export {
  colorVariable,
  createSpacingVariableFromKey,
  cssFontSizeToken,
  cssLeadingToken,
  gapVariables,
  marginVariables,
  opacityToClassName,
  paddingVariables,
  radiusVariables
};
